const dashboardConfig = {
  DASHBOARD_1: {
    key: "DASHBOARD_1",
    title: "Your Supplemental Compensation",
    subtitles: ["Compensation marked paid on national and local deals."],
    pageID: "kZBvr",
  },
  DASHBOARD_2: {
    key: "DASHBOARD_2",
    title: "AccessPlus Monthly Statement",
    subtitles: [],
    pageID: "KZRJx",
  },
  DASHBOARD_3: {
    key: "DASHBOARD_3",
    title: "ISM Dashboard - PMSF",
    subtitles: [
      "This dashboard represents your PMSF share on National and Local distributions.",
      "Click the funnel icon in the upper right corner of the dashboard to show and add available filters. \nClick on the “⛶” icon, found in each card’s upper right corner, to maximize each individual card. \nTables may be exported to Excel by clicking “⍐” in the upper right corner.",
      "Expand the cards to view the breakdown of Profit-sharing distribution for your agency. \nYou may find your information on National Deals and Programs on top and Local Incentives on the bottom.",
    ],
    pageID: "pY13r",
  },
  DASHBOARD_4: {
    key: "DASHBOARD_4",
    title: "ISM Dashboard - Premiums",
    subtitles: [
      "This dashboard represents SPC premiums over the last 12 months.",
      "Click the funnel icon in the upper right corner of the dashboard to show and add additional filters. \nClick on the “⛶” icon, found in each card’s upper right corner, to maximize each individual card. \nOnce expanded, you may further drill down into the card by clicking the data displayed. \nTables may be exported to Excel by clicking “⍐” in the upper right corner.",
      "Drill down into the top card to view the selected month’s SPC Penetration. Drill down even further to view the breakdown of Premiums by Company and Line of Business. \nDrill down into the bottom card to view this year’s premium compared to the previous year’s. \nDrill down further to view this year’s premium compared to the previous year’s by Company, Line of Business and premium type.",
    ],
    pageID: "r08KL",
  },
};

export default dashboardConfig;